/**
 * Where the board's Rillet numbers come from (quick-261104-ia3).
 * The live `rillet` panel (written by the on-demand refresh button) wins; until
 * the first refresh the bundled dated snapshot (rillet-arr.ts) is used.
 */
import { useExecPanels } from '../../queries/useExecPanels.js';

import {
  RILLET_CUSTOMER_COUNT,
  RILLET_MONTHS,
  RILLET_PROVISIONAL_MONTH,
  RILLET_PULLED_ON,
  RILLET_RENEWALS,
  RILLET_TOP_CUSTOMERS,
} from './rillet-arr.js';

import type { ExecResponse, ExecRilletPanel } from '@saledash/shared';

export const RILLET_SNAPSHOT: ExecRilletPanel = {
  pulledOn: RILLET_PULLED_ON,
  provisionalMonth: RILLET_PROVISIONAL_MONTH,
  months: RILLET_MONTHS,
  topCustomers: RILLET_TOP_CUSTOMERS,
  customerCount: RILLET_CUSTOMER_COUNT,
  renewals: RILLET_RENEWALS,
};

export function rilletFrom(exec: ExecResponse | undefined): ExecRilletPanel {
  return exec?.panels.rillet?.payload ?? RILLET_SNAPSHOT;
}

export function useRillet(): ExecRilletPanel {
  const { data } = useExecPanels();
  return rilletFrom(data);
}
